import React from 'react';
import { connect } from 'react-redux';
import {
  view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7,
  view_0E8B6D0D_0ADA_40F4_B5DB_EDA1D93F00A0,
  view_C024F6CB_821D_4DA1_8439_E8480C14D3C1,
  view_34469723_3B6D_44AD_8387_A099FC22956B,
  view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40
} from 'constants/viewType';
import OfferAdditionalDataComponentAlpha from 'features/offer/edit/financials/additionalData/components/OfferAdditionalDataComponentAlpha';
import OfferAdditionalDataComponentBeta from 'features/offer/edit/financials/additionalData/components/OfferAdditionalDataComponentBeta';
import OfferAssetContainerAlpha from 'features/offer/edit/assets/asset/components/OfferAssetContainerAlpha';
import OfferAssetComponentAlpha from 'features/offer/edit/assets/asset/components/OfferAssetComponentAlpha';
import ActivityFieldsContainerAlpha from 'features/offer/edit/client/activities/components/ActivityFieldsContainerAlpha';
import OfferAssetGeneralDetailsComponentAlpha from 'features/offer/edit/assets/generalDetails/components/OfferAssetGeneralDetailsComponentAlpha';
import FolderGeneralInfoContainerAlpha from 'features/folder/edit/generalData/info/components/FolderGeneralInfoContainerAlpha';
import CommissionsComponent_C187F9E5_83C2_4DBD_ADA7_B17523A862C7 from 'features/offer/edit/financials/commissions/components/CommissionsComponent_C187F9E5_83C2_4DBD_ADA7_B17523A862C7';
import OfferFinancialServicesContainerExtendedFields from 'features/offer/edit/financials/financialServices/components/OfferFinancialServicesContainerExtendedFields';
import DocumentScoringContainerAlpha from '../features/document/edit/scoring/components/DocumentScoringContainerAlpha';
import DocumentScoringContainerBeta from '../features/document/edit/scoring/components/DocumentScoringContainerBeta';
import FolderSidebarContainerAlpha from 'features/folder/sidebar/FolderSidebarContainerAlpha';
import FolderSidebarContainerBeta from 'features/folder/sidebar/FolderSidebarContainerBeta';
import FolderDocumentsContainerAlpha from 'features/folder/edit/documents/components/FolderDocumentsContainerAlpha';
import DecisionSummaryContainerAlpha from 'features/document/edit/decision/summary/components/DecisionSummaryContainerAlpha';
import OfferFinancingStructureComponentAlpha from 'components/offer/edit/financials/financingStructure/OfferFinancingStructureComponentAlpha';
import OfferAssetPartnerTypeComponentAlpha from 'features/offer/edit/assets/asset/components/OfferAssetPartnerTypeComponentAlpha';

/* eslint-disable no-alert, react/display-name */
/* eslint-disable no-alert, react/prop-types */
const customComponents = {
  OfferAdditionalDataComponent: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: OfferAdditionalDataComponentAlpha,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: OfferAdditionalDataComponentAlpha,
    [view_0E8B6D0D_0ADA_40F4_B5DB_EDA1D93F00A0]: OfferAdditionalDataComponentBeta,
    [view_C024F6CB_821D_4DA1_8439_E8480C14D3C1]: OfferAdditionalDataComponentBeta,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: OfferAdditionalDataComponentAlpha
  },
  FolderSidebarContainer: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: FolderSidebarContainerAlpha,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: FolderSidebarContainerAlpha,
    [view_0E8B6D0D_0ADA_40F4_B5DB_EDA1D93F00A0]: FolderSidebarContainerBeta,
    [view_C024F6CB_821D_4DA1_8439_E8480C14D3C1]: FolderSidebarContainerBeta,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: FolderSidebarContainerAlpha
  },
  OfferAssetGeneralDetailsComponent: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: OfferAssetGeneralDetailsComponentAlpha,
    [view_0E8B6D0D_0ADA_40F4_B5DB_EDA1D93F00A0]: OfferAssetGeneralDetailsComponentAlpha,
    [view_C024F6CB_821D_4DA1_8439_E8480C14D3C1]: OfferAssetGeneralDetailsComponentAlpha,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: OfferAssetGeneralDetailsComponentAlpha,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: OfferAssetGeneralDetailsComponentAlpha
  },
  ActivityFieldsContainer: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: ActivityFieldsContainerAlpha,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: ActivityFieldsContainerAlpha,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: ActivityFieldsContainerAlpha
  },
  FolderGeneralInfoContainer: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: FolderGeneralInfoContainerAlpha,
    [view_0E8B6D0D_0ADA_40F4_B5DB_EDA1D93F00A0]: FolderGeneralInfoContainerAlpha,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: FolderGeneralInfoContainerAlpha,
    [view_C024F6CB_821D_4DA1_8439_E8480C14D3C1]: FolderGeneralInfoContainerAlpha,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: FolderGeneralInfoContainerAlpha
  },
  OfferFinancialServicesContainer: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: OfferFinancialServicesContainerExtendedFields,
    [view_0E8B6D0D_0ADA_40F4_B5DB_EDA1D93F00A0]: OfferFinancialServicesContainerExtendedFields,
    [view_C024F6CB_821D_4DA1_8439_E8480C14D3C1]: OfferFinancialServicesContainerExtendedFields,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: OfferFinancialServicesContainerExtendedFields,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: OfferFinancialServicesContainerExtendedFields
  },
  OfferFinancingStructureComponent: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: OfferFinancingStructureComponentAlpha,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: OfferFinancingStructureComponentAlpha,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: OfferFinancingStructureComponentAlpha
  },
  OfferAssetComponent: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: OfferAssetComponentAlpha,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: OfferAssetComponentAlpha,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: OfferAssetComponentAlpha
  },
  OfferAssetContainer: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: OfferAssetContainerAlpha,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: OfferAssetContainerAlpha,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: OfferAssetContainerAlpha
  },
  OfferAssetPartnerTypeComponent: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: OfferAssetPartnerTypeComponentAlpha,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: OfferAssetPartnerTypeComponentAlpha,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: OfferAssetPartnerTypeComponentAlpha
  },
  DocumentScoringContainer: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: DocumentScoringContainerAlpha,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: DocumentScoringContainerAlpha,
    [view_0E8B6D0D_0ADA_40F4_B5DB_EDA1D93F00A0]: DocumentScoringContainerBeta,
    [view_C024F6CB_821D_4DA1_8439_E8480C14D3C1]: DocumentScoringContainerBeta,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: DocumentScoringContainerAlpha
  },
  CommissionsComponent: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: CommissionsComponent_C187F9E5_83C2_4DBD_ADA7_B17523A862C7,
    [view_0E8B6D0D_0ADA_40F4_B5DB_EDA1D93F00A0]: CommissionsComponent_C187F9E5_83C2_4DBD_ADA7_B17523A862C7,
    [view_C024F6CB_821D_4DA1_8439_E8480C14D3C1]: CommissionsComponent_C187F9E5_83C2_4DBD_ADA7_B17523A862C7,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: CommissionsComponent_C187F9E5_83C2_4DBD_ADA7_B17523A862C7,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: CommissionsComponent_C187F9E5_83C2_4DBD_ADA7_B17523A862C7
  },
  FolderDocumentsContainer: {
    [view_C187F9E5_83C2_4DBD_ADA7_B17523A862C7]: FolderDocumentsContainerAlpha,
    [view_34469723_3B6D_44AD_8387_A099FC22956B]: FolderDocumentsContainerAlpha,
    [view_0E8B6D0D_0ADA_40F4_B5DB_EDA1D93F00A0]: FolderDocumentsContainerAlpha,
    [view_C024F6CB_821D_4DA1_8439_E8480C14D3C1]: FolderDocumentsContainerAlpha,
    [view_DA881A4C_7D6D_4F0D_A8E0_AC82C140FC40]: FolderDocumentsContainerAlpha
  },
  DecisionSummaryContainer: {
    [view_0E8B6D0D_0ADA_40F4_B5DB_EDA1D93F00A0]: DecisionSummaryContainerAlpha,
    [view_C024F6CB_821D_4DA1_8439_E8480C14D3C1]: DecisionSummaryContainerAlpha
  }
};

/**
 *
 * @param {String} componentName Component name used to find the overriding component in the configured customComponents
 */
const withCustomComponent =
  componentName =>
  DefaultComponent =>
  ({ viewType, loading, ...rest }) => {
    if (loading) return null;
    const configComponent = Object.keys(customComponents).find(x => componentName === x);

    if (!configComponent)
      throw new Error(`withCustomComponent error: Component name '${componentName}' does not have any custom components defined.`);

    const Component = customComponents[configComponent][viewType] || DefaultComponent;

    return <Component {...rest} />;
  };

function mapStateToProps(state) {
  const { viewType } = state.params.items;
  const { loading } = state.params;
  return {
    viewType: viewType,
    loading: loading
  };
}

/**
 *
 * @param {String} componentName Component name used to find the overriding component in the configured customComponents.
 */
const exp = componentName => Component => connect(mapStateToProps)(withCustomComponent(componentName)(Component));
export default exp;
